/**
 * usePrinterService hook
 * Provides React component access to printer service functionality
 */

import { printerService } from '../printer/printerService';

export const usePrinterService = () => printerService;
